export default __webpack_public_path__ + "7fb0ff877ad29ce86f471f3f1ac14464.png";